import Swal from "sweetalert2";
import "./swal.scss";
export function showSwalQuestion(title, success = "بله", cancel = "خیر") {
  return Swal.fire({
    title,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: success,
    cancelButtonText: cancel,
    customClass: {
      container: "custom-sweetalert",
    },
  });
}
export function showSwalError(error) {
  return Swal.fire({
    title: "خطا!" + error,
    icon: "error",
    showConfirmButton: false,
    timer: 70000,
    customClass: {
      container: "custom-sweetalert",
    },
  });
}
export function showSwalSuccess(title) {
  return Swal.fire({
    title,
    icon: "success",
    showConfirmButton: false,
    timer: 50000,
    customClass: {
      container: "custom-sweetalert",
    },
  });
}

export function showSwalInfo(title) {
  return Swal.fire({
    text: title,
    icon: "info",
    showConfirmButton: false,
    timer: 150000,
    customClass: {
      container: "custom-sweetalert",
    },
  });
}
